import { put, takeLatest } from 'redux-saga/effects';
import { signup, signin, success, failed } from '../slice/userSlice';
import { postRequest, getRequest, deleteRequest, patchRequest } from './ApiInstence';
import { toast } from 'react-toastify';
import { getContactUs, successContactUs, failedContactUs, removeContactUs, getDashboardData } from '../slice/contactUsSlice';
import { addProduct, getProduct, updateProduct, successProduct, removeProduct, getOneProduct, searchProductByName } from '../slice/productSlice';
import { getGallery, successGallery, removeGallery, addGallery, updateGallery, getOneGallery } from '../slice/gallerySlice';
import { getBanner, successBanner, removeBanner, addBanner, updateBanner, getOneBanner } from '../slice/bannerSlice';
import { getCustomer, successCustomer, removeCustomer, addCustomer, updateCustomer, getOneCustomer, searchByMobile } from '../slice/customerSlice';
import { addOrderListDB, getOrderListDB, getOrderDeatilsDB, successOrderListDB, failedOrderListDB, updateOrderListDB } from '../slice/orderSliceDB';
import { updateOrderAPI } from './orderAPI/orderAPI';
import { addShowroomCategory, getShowroomCategory, successShowroomCategory, failedShowroomCategory, removeShowroomCategory, updateShowroomCategory } from '../slice/showroomCategorySlice';
import { addShowroomDealer, getShowroomDealer, removeShowroomDealer, successShowroomDealer, updateShowroomDealer } from "../slice/showroomDealerSlice";
import { getBlogs, getOneBlog, addBlog, updateBlog, removeBlog, successBlogs, successOneBlog } from "../slice/blogSlice";
import { getEvents, getOneEvent, addEvent, updateEvent, removeEvent, successEvents, successOneEvent } from "../slice/eventSlice";
import { getPages, removePage, successPages } from "../slice/pageSlice";

// Generator function
function* signinUser({ payload }) {
  try {
    let response = yield postRequest('admin/signin', payload, {
      withCredentials: true,
    });
    if (response?.data?.access_token || response?.status === 200) {
      yield put(success(response));
    } else {
      yield put(failed({ message: response?.data?.message || response?.message || 'Invalid email or password' }));
    }
  } catch (error) {
    yield put(failed({ message: error?.message || error?.response?.data?.message || 'Invalid email or password' }));
  }
}

function* signupUser({ payload }) {
  try {
    const response = yield postRequest('register', payload);
    if (response?.status == 200) {
      yield put(success(response?.data));
    } else {
      yield put(failed(response));
    }
  } catch (error) {
    console.log(error)
    toast('resposnse.message')
  }
}

function* getContactUsFun({ payload }) {
  try {
    const response = yield getRequest('contactus', payload);
    if (response?.status == 200) {
      yield put(successContactUs(response?.data));
    } else {
      yield put(failedContactUs(response));
    }
  } catch (error) {
    console.log(error)
    toast('resposnse.message')
  }
}

function* getDashboardDataFun({ payload }) {
  try {
    const response = yield getRequest('dashboard', payload);
    if (response?.status == 200) {
      yield put(successContactUs(response?.data));
    } else {
      yield put(failedContactUs(response));
    }
  } catch (error) {
    console.log(error)
    toast('resposnse.message')
  }
}


function* getProductFun() {
  try {
    const response = yield getRequest('product');
    if (response?.status == 200) {
      yield put(successProduct(response?.data));
    } else {
      yield put(failedContactUs(response));
    }
  } catch (error) {
    console.log(error)
    toast('resposnse.message')
  }
}

function* getOneProductFun({ payload }) {
  try {
    const response = yield getRequest(`product/one/${payload}`);
    if (response?.status == 200) {
      yield put(successProduct(response?.data));
    } else {
      yield put(failedContactUs(response));
    }
  } catch (error) {
    console.log(error)
    toast('resposnse.message')
  }
}

function* removeContactUsFun({ payload }) {
  try {
    const response = yield deleteRequest(`contactus/${payload}`);
    if (response?.status == 200) {
      const response = yield getRequest('contactus', payload);
      yield put(successContactUs(response?.data));
    } else {
      yield put(failedContactUs(response));
    }
  } catch (error) {
    console.log(error)
    toast('resposnse.message')
  }
}

function* removeProductFun({ payload }) {
  try {
    const response = yield deleteRequest(`product/${payload}`);
    if (response?.status == 200) {
      const response = yield getRequest('product', payload);
      yield put(successProduct(response?.data));
    } else {
      yield put(failedContactUs(response));
    }
  } catch (error) {
    console.log(error)
    toast('resposnse.message')
  }
}

function* addProductFun({ payload }) {
  try {
    const response = yield postRequest(`product`, payload);
    if (response?.status == 200) {
      yield put(successProduct(response?.data));
    } else {
      yield put(failedContactUs(response));
    }
  } catch (error) {
    console.log(error)
    toast('resposnse.message')
  }
}

function* searchProductByNameFun({ payload }) {
  try {
    const response = yield getRequest(`product/search?product=${payload}`);
    if (response?.status == 200) {
      yield put(successProduct(response?.data));
    } else {
      yield put(failedContactUs(response));
    }
  } catch (error) {
    console.log(error)
    toast('resposnse.message')
  }
}

function* updateProductFun({ payload }) {
  try {
    const response = yield patchRequest(`product/${payload.id}`, payload.data);
    if (response?.status == 200) {
      yield put(successProduct(response?.data));
    } else {
      yield put(failedContactUs(response));
    }
  } catch (error) {
    console.log(error)
    toast('resposnse.message')
  }
}

//Gallery Functions 
function* getGalleryFun() {
  try {
    const response = yield getRequest('gallery'); // no second argument

    if (response?.status == 200) {
      yield put(successGallery(response?.data));
    } else {
      yield put(failedContactUs(response));
    }
  } catch (error) {
    console.log(error)
    toast('resposnse.message')
  }
}

function* getOneGalleryFun({ payload }) {
  try {
    const response = yield getRequest(`galleries/one/${payload}`);
    if (response?.status == 200) {
      yield put(successGallery(response?.data));
    } else {
      yield put(failedContactUs(response));
    }
  } catch (error) {
    console.log(error)
    toast('resposnse.message')
  }
}

function* removeGalleryFun({ payload }) {
  try {
    const response = yield deleteRequest(`galleries/${payload}`);
    if (response?.status == 200) {
      const response = yield getRequest('galleries', payload);
      yield put(successGallery(response?.data));
    } else {
      yield put(failedContactUs(response));
    }
  } catch (error) {
    console.log(error)
    toast('resposnse.message')
  }
}

function* addGalleryFun({ payload }) {
  try {
    const response = yield postRequest(`galleries`, payload);
    if (response?.status == 200) {
      yield put(successGallery(response?.data));
    } else {
      yield put(failedContactUs(response));
    }
  } catch (error) {
    console.log(error)
    toast('resposnse.message')
  }
}

function* updateGalleryFun({ payload }) {
  try {
    const response = yield patchRequest(`galleries/${payload.id}`, payload.data);
    if (response?.status == 200) {
      yield put(successGallery(response?.data));
    } else {
      yield put(failedContactUs(response));
    }
  } catch (error) {
    console.log(error)
    toast('resposnse.message')
  }
}



//Banner Start
function* getBannerFun() {
  try {
    const response = yield getRequest('banner');
    if (response?.status == 200) {
      yield put(successBanner(response?.data));
    } else {
      yield put(failedContactUs(response));
    }
  } catch (error) {
    console.log(error)
    toast('resposnse.message')
  }
}

function* getOneBannerFun({ payload }) {
  try {
    const response = yield getRequest(`banner/one/${payload}`);
    if (response?.status == 200) {
      yield put(successBanner(response?.data));
    } else {
      yield put(failedContactUs(response));
    }
  } catch (error) {
    console.log(error)
    toast('resposnse.message')
  }
}

function* removeBannerFun({ payload }) {
  try {
    const response = yield deleteRequest(`banner/${payload}`);
    if (response?.status == 200) {
      const response = yield getRequest('banner', payload);
      yield put(successBanner(response?.data));
    } else {
      yield put(failedContactUs(response));
    }
  } catch (error) {
    console.log(error)
    toast('resposnse.message')
  }
}

function* addBannerFun({ payload }) {
  try {
    const response = yield postRequest(`banner`, payload);
    if (response?.status == 200) {
      yield put(successBanner(response?.data));
    } else {
      yield put(failedContactUs(response));
    }
  } catch (error) {
    console.log(error)
    toast('resposnse.message')
  }
}

function* updateBannerFun({ payload }) {
  try {
    const response = yield patchRequest(`banner/${payload.id}`, payload.data);
    if (response?.status == 200) {
      yield put(successBanner(response?.data));
    } else {
      yield put(failedContactUs(response));
    }
  } catch (error) {
    console.log(error)
    toast('resposnse.message')
  }
}

//Banner End 




// customer start
function* addCustomerFun({ payload }) {
  try {
    const response = yield postRequest(`customer`, payload);
    if (response?.status == 200) {
      yield put(successCustomer(response?.data));
    } else {
      yield put(failedOurteam(response));
    }
  } catch (error) {
    console.log(error)
    toast('resposnse.message')
  }
}


export function* getCustomerFun() {
  try {
    const response = yield getRequest('customers'); // Your API endpoint
    if (response?.status === 200) {
      yield put(successCustomer(response.data));
    } else {
      yield put(failedCustomer(response.message || "Failed to fetch customers"));
    }
  } catch (error) {
    console.error('Saga error:', error);
    toast.error(error?.response?.data?.message || "Error fetching customers");
    yield put(failedCustomer(error?.response?.data?.message || "Fetch failed"));
  }
}

function* removeCustomerFun({ payload }) {
  try {
    const response = yield deleteRequest(`customers/${payload}`);
    if (response?.status == 200) {
      const response = yield getRequest('customers', payload);
      yield put(successCustomer(response?.data));
    } else {
      yield put(failedOurteam(response));
    }
  } catch (error) {
    console.log(error)
    toast('resposnse.message')
  }
}

function* getOneCustomerFun({ payload }) {
  try {
    const response = yield getRequest(`customers/one/${payload}`);
    if (response?.status == 200) {
      yield put(successCustomer(response?.data));
    } else {
      yield put(failedOurteam(response));
    }
  } catch (error) {
    console.log(error)
    toast('resposnse.message')
  }
}

function* updateCustomerFun({ payload }) {
  try {
    let header = {
      'Content-Type': 'multipart/form-data'
    }
    const response = yield patchRequest(`customers/${payload.id}`, payload.data, header);
    if (response?.status == 200) {
      yield put(successCustomer(response?.data));
    } else {
      yield put(failedOurteam(response));
    }
  } catch (error) {
    console.log(error)
    toast('resposnse.message')
  }
}

function* searchByMobileFun({ payload }) {
  try {
    const response = yield getRequest(`customers/search?name=${payload}`);
    if (response?.status == 200) {
      yield put(successCustomer(response?.data));
    } else {
      yield put(failedContactUs(response));
    }
  } catch (error) {
    console.log(error)
    toast('resposnse.message')
  }
}

// customer end

// order list DB start
function* addOrderListDBFun({ payload }) {
  try {
    const response = yield postRequest(`order`, payload);
    if (response?.status == 200) {
      yield put(successOrderListDB(response?.data));
    } else {
      yield put(failedOrderListDB(response));
    }
  } catch (error) {
    console.log(error)
    toast('resposnse.message')
  }
}

function* getOrderListDBFun() {
  try {
    const response = yield getRequest('order');
    if (response?.status == 200) {
      yield put(successOrderListDB(response?.data));
    } else {
      yield put(failedOrderListDB(response));
    }
  } catch (error) {
    console.log(error)
    toast('resposnse.message')
  }
}

function* getOrderDeatilsDBFun({payload}) {
  try {
    const response = yield getRequest(`order/order_details/${payload}`);
    if (response?.status == 200) {
      yield put(successOrderListDB(response?.data));
    } else {
      yield put(failedOrderListDB(response));
    }
  } catch (error) {
    console.log(error)
    toast('resposnse.message')
  }
}




// Showroom Category start
function* addShowroomCategoryFun({ payload }) {
  try {
    const response = yield postRequest(`showroom-categories`, payload);
    if (response?.status == 201 || response?.status == 200) {
      const fetchResponse = yield getRequest('showroom-categories');
      if (fetchResponse?.status == 200) {
        yield put(successShowroomCategory(fetchResponse?.data));
      }
    } else {
      yield put(failedShowroomCategory(response));
    }
  } catch (error) {
    console.log(error);
    toast.error('Failed to add category');
  }
}

function* getShowroomCategoryFun() {
  try {
    const response = yield getRequest('showroom-categories');
    if (response?.status == 200) {
      yield put(successShowroomCategory(response?.data));
    } else {
      yield put(failedShowroomCategory(response));
    }
  } catch (error) {
    console.log(error);
    toast.error('Failed to fetch categories');
  }
}

function* removeShowroomCategoryFun({ payload }) {
  try {
    const response = yield deleteRequest(`showroom-categories/${payload}`);
    if (response?.status == 200) {
      const fetchResponse = yield getRequest('showroom-categories');
      if (fetchResponse?.status == 200) {
        yield put(successShowroomCategory(fetchResponse?.data));
      }
    } else {
      yield put(failedShowroomCategory(response));
    }
  } catch (error) {
    console.log(error);
    toast.error('Failed to remove category');
  }
}

function* updateShowroomCategoryFun({ payload }) {
  try {
    const response = yield patchRequest(`showroom-categories/${payload.id}`, payload.data);
    if (response?.status == 200) {
      const fetchResponse = yield getRequest('showroom-categories');
      if (fetchResponse?.status == 200) {
        yield put(successShowroomCategory(fetchResponse?.data));
      }
    } else {
      yield put(failedShowroomCategory(response));
    }
  } catch (error) {
    console.log(error);
    toast.error('Failed to update category');
  }
}
// Showroom Category end

// Showroom Dealer Sagas
function* getShowroomDealerFun() {
  try {
    const response = yield getRequest('showroom-dealers');
    if (response?.status == 200) {
      yield put(successShowroomDealer(response?.data));
    } else {
      toast.error('Failed to fetch dealers: ' + (response?.message || 'Unknown error'));
      yield put(successShowroomDealer([])); // To stop loading
    }
  } catch (error) {
    console.error('getShowroomDealerFun error:', error);
    toast.error('Failed to fetch dealers (catch): ' + error.message);
    yield put(successShowroomDealer([])); // To stop loading
  }
}

function* addShowroomDealerFun({ payload }) {
  try {
    const response = yield postRequest(`showroom-dealers`, payload);
    if (response?.status == 201 || response?.status == 200) {
      const fetchResponse = yield getRequest('showroom-dealers');
      if (fetchResponse?.status == 200) {
        yield put(successShowroomDealer(fetchResponse?.data));
        toast.success(response.data.message || 'Dealer added successfully');
      }
    } else {
      toast.error('Failed to add dealer');
    }
  } catch (error) {
    console.log(error);
    toast.error('Server Error');
  }
}

function* updateShowroomDealerFun({ payload }) {
  try {
    const response = yield patchRequest(`showroom-dealers/${payload.id}`, payload.data);
    if (response?.status == 200) {
      const fetchResponse = yield getRequest('showroom-dealers');
      if (fetchResponse?.status == 200) {
        yield put(successShowroomDealer(fetchResponse?.data));
        toast.success(response.data.message || 'Dealer updated successfully');
      }
    } else {
      toast.error('Failed to update dealer');
    }
  } catch (error) {
    console.log(error);
    toast.error('Server Error');
  }
}

function* removeShowroomDealerFun({ payload }) {
  try {
    const response = yield deleteRequest(`showroom-dealers/${payload}`);
    if (response?.status == 200) {
      const fetchResponse = yield getRequest('showroom-dealers');
      if (fetchResponse?.status == 200) {
        yield put(successShowroomDealer(fetchResponse?.data));
        toast.success('Dealer deleted successfully');
      }
    } else {
      toast.error('Failed to delete dealer');
    }
  } catch (error) {
    console.log(error);
    toast.error('Server Error');
  }
}

// Blog Sagas
function* getBlogsFun() {
  try {
    const response = yield getRequest('blogs');
    if (response?.status === 200) {
      yield put(successBlogs(response.data));
    }
  } catch (error) {
    console.error('getBlogsFun error:', error);
  }
}

function* getOneBlogFun({ payload }) {
  try {
    const response = yield getRequest(`blogs/${payload}`);
    if (response?.status === 200) {
      yield put(successOneBlog(response.data));
    }
  } catch (error) {
    console.error('getOneBlogFun error:', error);
  }
}

function* addBlogFun({ payload }) {
  try {
    const response = yield postRequest('blogs', payload);
    if (response?.status === 201 || response?.status === 200) {
      toast.success('Blog created successfully');
      const fetchResponse = yield getRequest('blogs');
      if (fetchResponse?.status === 200) {
        yield put(successBlogs(fetchResponse.data));
      }
    }
  } catch (error) {
    console.error(error);
    toast.error('Failed to add blog');
  }
}

function* updateBlogFun({ payload }) {
  try {
    const response = yield patchRequest(`blogs/${payload.id}`, payload.data);
    if (response?.status === 200) {
      toast.success('Blog updated successfully');
      const fetchResponse = yield getRequest('blogs');
      if (fetchResponse?.status === 200) {
        yield put(successBlogs(fetchResponse.data));
      }
    }
  } catch (error) {
    console.error(error);
    toast.error('Failed to update blog');
  }
}

function* removeBlogFun({ payload }) {
  try {
    const response = yield deleteRequest(`blogs/${payload}`);
    if (response?.status === 200) {
      toast.success('Blog deleted successfully');
      const fetchResponse = yield getRequest('blogs');
      if (fetchResponse?.status === 200) {
        yield put(successBlogs(fetchResponse.data));
      }
    }
  } catch (error) {
    console.error(error);
    toast.error('Failed to delete blog');
  }
}

// Event Sagas
function* getEventsFun() {
  try {
    const response = yield getRequest('events');
    if (response?.status === 200) {
      yield put(successEvents(response.data));
    }
  } catch (error) {
    console.error('getEventsFun error:', error);
  }
}

function* getOneEventFun({ payload }) {
  try {
    const response = yield getRequest(`events/${payload}`);
    if (response?.status === 200) {
      yield put(successOneEvent(response.data));
    }
  } catch (error) {
    console.error('getOneEventFun error:', error);
  }
}

function* addEventFun({ payload }) {
  try {
    const response = yield postRequest('events', payload);
    if (response?.status === 201 || response?.status === 200) {
      toast.success('Event created successfully');
      const fetchResponse = yield getRequest('events');
      if (fetchResponse?.status === 200) {
        yield put(successEvents(fetchResponse.data));
      }
    }
  } catch (error) {
    console.error(error);
    toast.error('Failed to add event');
  }
}

function* updateEventFun({ payload }) {
  try {
    const response = yield patchRequest(`events/${payload.id}`, payload.data);
    if (response?.status === 200) {
      toast.success('Event updated successfully');
      const fetchResponse = yield getRequest('events');
      if (fetchResponse?.status === 200) {
        yield put(successEvents(fetchResponse.data));
      }
    }
  } catch (error) {
    console.error(error);
    toast.error('Failed to update event');
  }
}

function* removeEventFun({ payload }) {
  try {
    const response = yield deleteRequest(`events/${payload}`);
    if (response?.status === 200) {
      toast.success('Event deleted successfully');
      const fetchResponse = yield getRequest('events');
      if (fetchResponse?.status === 200) {
        yield put(successEvents(fetchResponse.data));
      }
    }
  } catch (error) {
    console.error(error);
    toast.error('Failed to delete event');
  }
}

// Page Sagas
function* getPagesFun() {
  try {
    const response = yield getRequest('pages');
    if (response?.status === 200) {
      yield put(successPages(response.data));
    }
  } catch (error) {
    console.error('getPagesFun error:', error);
  }
}

function* removePageFun({ payload }) {
  try {
    const response = yield deleteRequest(`pages/${payload}`);
    if (response?.status === 200) {
      toast.success('Page deleted successfully');
      const fetchResponse = yield getRequest('pages');
      if (fetchResponse?.status === 200) {
        yield put(successPages(fetchResponse.data));
      }
    }
  } catch (error) {
    console.error(error);
    toast.error('Failed to delete page');
  }
}

// Generator function
export function* watchGetUser() {
  yield takeLatest(signin, signinUser);
  yield takeLatest(signup, signupUser);

  // contact us
  yield takeLatest(getContactUs, getContactUsFun);
  yield takeLatest(getDashboardData, getDashboardDataFun);
  yield takeLatest(removeContactUs, removeContactUsFun);

  //Product
  yield takeLatest(addProduct, addProductFun);
  yield takeLatest(getProduct, getProductFun);
  yield takeLatest(getOneProduct, getOneProductFun);
  yield takeLatest(searchProductByName, searchProductByNameFun);
  yield takeLatest(removeProduct, removeProductFun);
  yield takeLatest(updateProduct, updateProductFun);

  //gallery
  yield takeLatest(addGallery, addGalleryFun);
  yield takeLatest(getGallery, getGalleryFun);
  yield takeLatest(removeGallery, removeGalleryFun);
  yield takeLatest(getOneGallery, getOneGalleryFun);
  yield takeLatest(updateGallery, updateGalleryFun);

  //Banner
  yield takeLatest(addBanner, addBannerFun);
  yield takeLatest(getBanner, getBannerFun);
  yield takeLatest(removeBanner, removeBannerFun);
  yield takeLatest(getOneBanner, getOneBannerFun);
  yield takeLatest(updateBanner, updateBannerFun);

  //Customer
  yield takeLatest(addCustomer, addCustomerFun);
  yield takeLatest(getCustomer, getCustomerFun);
  yield takeLatest(removeCustomer, removeCustomerFun);
  yield takeLatest(getOneCustomer, getOneCustomerFun);
  yield takeLatest(updateCustomer, updateCustomerFun);
  yield takeLatest(searchByMobile, searchByMobileFun);

  // order DB
  yield takeLatest(addOrderListDB, addOrderListDBFun);
  yield takeLatest(getOrderListDB, getOrderListDBFun);
  yield takeLatest(getOrderDeatilsDB, getOrderDeatilsDBFun);
  yield takeLatest(updateOrderListDB, updateOrderAPI);

  // Showroom Category
  yield takeLatest(addShowroomCategory, addShowroomCategoryFun);
  yield takeLatest(getShowroomCategory, getShowroomCategoryFun);
  yield takeLatest(removeShowroomCategory, removeShowroomCategoryFun);
  yield takeLatest(updateShowroomCategory, updateShowroomCategoryFun);

  // Showroom Dealer
  yield takeLatest(addShowroomDealer, addShowroomDealerFun);
  yield takeLatest(getShowroomDealer, getShowroomDealerFun);
  yield takeLatest(removeShowroomDealer, removeShowroomDealerFun);
  yield takeLatest(updateShowroomDealer, updateShowroomDealerFun);

  // Blogs
  yield takeLatest(getBlogs, getBlogsFun);
  yield takeLatest(getOneBlog, getOneBlogFun);
  yield takeLatest(addBlog, addBlogFun);
  yield takeLatest(updateBlog, updateBlogFun);
  yield takeLatest(removeBlog, removeBlogFun);

  // Events
  yield takeLatest(getEvents, getEventsFun);
  yield takeLatest(getOneEvent, getOneEventFun);
  yield takeLatest(addEvent, addEventFun);
  yield takeLatest(updateEvent, updateEventFun);
  yield takeLatest(removeEvent, removeEventFun);

  // Pages
  yield takeLatest(getPages, getPagesFun);
  yield takeLatest(removePage, removePageFun);
}